module.exports = __webpack_public_path__ + "img/Deposito.aaef9b8d.png";